import React, {Component} from "react";
import {Col, Row} from "react-bootstrap";
import FormGroup from "react-bootstrap/FormGroup";
import {Button} from "reactstrap";
import HsmCertificateViewer from "../../common/hsm/HsmCertificateViewer";
import YoutubePlayer from "react-youtube-player";
import {request} from "../../helper/APIUtils";
import {VirtualHost} from "../../constants";

class SignatureInformation extends Component {
    constructor() {
        super();
        this.state = {
            selectedCertificate: "",
            video:{}
        }
        this.renderRemainingDate = this.renderRemainingDate.bind(this);
        this.getHelpVideo = this.getHelpVideo.bind(this);
    }

    componentDidMount() {
        this.getHelpVideo();
    }

    getHelpVideo(){
        request({
            method: 'get',
            url: `/media/videos/SignatureInformation`
        }).then(response => {
            this.setState({ video: response.data[0] });
        }).catch(function (error) {
            console.log(error);
        });
    }

    renderRemainingDate() {
        // if (this.state.selectedCertificate !== "") {
        //     let layout = {};
        //     // let remainingDay = Math.abs(new Date(this.state.selectedCertificate.certificate.expiresOn) - new Date().getDate()) / (1000 * 60 * 60 * 24);
        //     let remainingDay = 0;
        //     if (remainingDay < 0) {
        //         layout.background = '#cd6e6e61';
        //         layout.color = '#A1A1A1';
        //         layout.fontSize = '15px';
        //     } else {
        //         layout.background = '#7fff5fad';
        //         layout.color = '#A1A1A1';
        //         layout.fontSize = '15px';
        //     }
        //     return (
        //         <div style={layout}>
        //             E-imzanızın süresinin bitmesine ${remainingDay / (1000*60*60*24)} gün kalmıştır.
        //         </div>
        //     )
        // } else {
        //     return <div/>;
        // }
    }

    render() {
        return (
            <div>
                <br/>
                <br/>
                <Row>
                    <Row style={{minHeight: '100px', paddingLeft: '180px'}}>
                        <Col sm={8} className="row">
                            <Row>
                                <Col sm={12}>
                                    <FormGroup row>
                                        <Col sm={12}>
                                            <h3 className="simple-card-header">
                                                E-imzanızı bilgisayara taktıktan sonra Sertifikaları Getir butonu ile
                                                e-imza bilgilerinize ulaşabilirsiniz.
                                            </h3>
                                        </Col>
                                        <Col sm={12}>
                                            <HsmCertificateViewer
                                                value={this.state.certificate}
                                                from="SignatureInformation"
                                                onChange={(val) => this.setState({certificate: val})}
                                            />

                                        </Col>
                                    </FormGroup>
                                </Col>
                            </Row>
                            {/*<Row>*/}
                            {/*    <Col sm={12}>*/}
                            {/*        <FormGroup row>*/}
                            {/*            <Col sm={12}>*/}
                            {/*                {*/}
                            {/*                    this.state.selectedCertificate && this.renderRemainingDate()*/}
                            {/*                }*/}
                            {/*            </Col>*/}
                            {/*        </FormGroup>*/}
                            {/*    </Col>*/}
                            {/*</Row>*/}
                            <Row>
                                <Col sm={12}>

                                    <FormGroup row>
                                        <Col sm={6}>
                                            <h3 style={{display: "inline"}} className="simple-card-header">Eczacıkart E-fatura'ya Başvurmak İçin
                                                Tıklayınız. </h3>
                                            <Button title="Başvur"
                                                    style={{background: 'green', fontWeight: "bold", fontSize: "15px"}}
                                                    onClick={() => window.open("http://eczacikartfatura.com/", "_blank")}>
                                                Başvur
                                            </Button>
                                        </Col>
                                    </FormGroup>
                                </Col>
                                <Col sm={12}>
                                    <FormGroup row>
                                        <Col sm={12}>
                                            <div className="col-xs-12"
                                                 style={{
                                                     padding: "50px 0 0 0",
                                                     display: "flex",
                                                     flexDirection: "column",
                                                     alignItems: "center",
                                                     width: "100%"
                                                 }}>
                                                <h2 className="simple-card-header">
                                                    e-İmza Sürücüleri İçin Aşağıdaki Bağlantıları Kullanabilirsiniz
                                                </h2>

                                                <div style={{display: "flex", flexDirection: "row"}}>
                                                    <div style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        padding: "0 20px"
                                                    }}>
                                                        <h2 className="simple-card-header">
                                                            <a href="https://kamusm.bilgem.tubitak.gov.tr/islemler/surucu_yukleme_servisi/"
                                                               target="_blank">KamuSM</a>
                                                        </h2>

                                                        <h2 className="simple-card-header">
                                                            <a href="http://www.e-imzatr.com.tr/TeknikDestek.aspx"
                                                               target="_blank">e-İmzaTR</a>
                                                        </h2>
                                                    </div>

                                                    <div style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        padding: "0 20px"
                                                    }}>
                                                        <h2 className="simple-card-header">
                                                            <a href="https://turkkep.com.tr/yukleme-merkezi/"
                                                               target="_blank">Türkkep</a>
                                                        </h2>

                                                        <h2 className="simple-card-header">
                                                            <a href="https://helpdesk.e-tugra.com.tr/765601-E-imza-aktivasyon-nas%C4%B1l-yap%C4%B1l%C4%B1r-yeni-e-imza-kurulumu?r=1"
                                                               target="_blank">e-Tuğra</a>
                                                        </h2>
                                                    </div>

                                                    <div style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        padding: "0 20px"
                                                    }}>
                                                        <h2 className="simple-card-header">
                                                            <a href="https://www.e-guven.com/destek-masasi/e-imza-yazilimlari/"
                                                               target="_blank">e-Güven</a>
                                                        </h2>

                                                        <h2 className="simple-card-header">
                                                            <a href="https://pttkep.gov.tr/e-imza/"
                                                               target="_blank">PTT</a>
                                                        </h2>
                                                    </div>

                                                    <div style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        padding: "0 20px"
                                                    }}>
                                                        <h2 className="simple-card-header">
                                                            <a href="https://www.turktrust.com.tr/tr/yardim/kurulum-islemleri/"
                                                               target="_blank">Türktrust</a>
                                                        </h2>

                                                        {/*<h2 className="simple-card-header">*/}
                                                        {/*    <a href="https://www.turmobeimza.com.tr"*/}
                                                        {/*       target="_blank">TÜRMOB</a>*/}
                                                        {/*</h2>*/}
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Col>
                        <Col sm={4}>
                            <YoutubePlayer
                                videoId={this.state.video && this.state.video.id}
                                playbackState='unstarted'
                            />
                        </Col>
                    </Row>
                </Row>
            </div>
        )
    }
}

export default SignatureInformation;